/* Stone Aura — premium interactions */
(function () {
  'use strict';

  /* Reveal on scroll */
  function initReveal() {
    var els = document.querySelectorAll('.sa-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('sa-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sa-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Header blur on scroll */
  function initHeader() {
    var onScroll = function () {
      document.body.classList.toggle('sa-header-scrolled', window.scrollY > 24);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Testimonial slider */
  function initTestimonials() {
    document.querySelectorAll('[data-sa-testimonials]').forEach(function (root) {
      var track = root.querySelector('.sa-testimonials__track');
      var dotsWrap = root.querySelector('.sa-testimonials__dots');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var perView = window.innerWidth >= 990 ? 2 : 1;
      var pages = Math.max(1, Math.ceil(slides.length / perView));
      var index = 0;
      var timer = null;

      function go(i) {
        index = (i + pages) % pages;
        var shift = (100 / perView) * perView * index;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        if (dotsWrap) {
          Array.prototype.forEach.call(dotsWrap.children, function (d, di) {
            d.classList.toggle('sa-testimonials__dot--active', di === index);
          });
        }
      }
      function auto() {
        clearInterval(timer);
        timer = setInterval(function () { go(index + 1); }, 6000);
      }
      if (dotsWrap) {
        for (var p = 0; p < pages; p++) {
          (function (pi) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'sa-testimonials__dot' + (pi === 0 ? ' sa-testimonials__dot--active' : '');
            b.setAttribute('aria-label', 'Go to slide ' + (pi + 1));
            b.addEventListener('click', function () { go(pi); auto(); });
            dotsWrap.appendChild(b);
          })(p);
        }
      }
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', auto);
      auto();
    });
  }

  /* Sticky add-to-cart on product pages */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sa-sticky-atc]');
    var form = document.querySelector('product-form, form[action*="/cart/add"]');
    if (!bar || !form) return;
    var onScroll = function () {
      var r = form.getBoundingClientRect();
      bar.classList.toggle('sa-sticky-atc--visible', r.bottom < 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var btn = bar.querySelector('[data-sa-sticky-submit]');
    if (btn) {
      btn.addEventListener('click', function () {
        var mainBtn = form.querySelector('[name="add"], button[type="submit"]');
        if (mainBtn) mainBtn.click();
      });
    }
  }

  /* FAQ: close others when one opens */
  function initFaq() {
    document.querySelectorAll('[data-sa-faq]').forEach(function (root) {
      root.querySelectorAll('details').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) {
            root.querySelectorAll('details').forEach(function (o) {
              if (o !== d) o.open = false;
            });
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  function boot() {
    initReveal();
    initHeader();
    initTestimonials();
    initStickyAtc();
    initFaq();
  }
})();
